module.exports = __webpack_public_path__ + "img/jihua.21e7ff01.png";